export default "__VITE_ASSET__BekzmoHV__"